/**
 * "What can the reviewer see" — the one definition of a visible lexicon match
 * (VE-24948 / U5).
 *
 * Its own module because it is a VIEW derivation, not merge policy. It lived in
 * `lexiconApply.ts` (the pure D13 merge) and was imported from there by both a
 * reducer and a component — and that dependency is what made review-gate B7
 * possible. The merge imports this, not the other way round.
 *
 * Both the apply panel's total and the detections list's per-lexicon breakdown
 * build on `visibleMatchIds`, so the two cannot drift into disagreeing about
 * the same document — which they did, in both directions, before it existed.
 */
import {
  Detection,
  LexiconSourcedDetection,
  isLexiconDetection,
} from './models';

/** Non-deleted match ids on ONE lexicon detection. */
export function visibleMatchIds(
  detection: LexiconSourcedDetection
): Set<string> {
  const deleted = new Set(detection.deletedMatchIds ?? []);
  const ids = new Set<string>();
  for (const occ of detection.occurrences) {
    for (const id of occ.matchIds ?? []) {
      if (!deleted.has(id)) {
        ids.add(id);
      }
    }
  }
  return ids;
}

/** Total visible lexicon matches across a detection list. */
export function countLexiconMatches(detections: readonly Detection[]): number {
  let total = 0;
  for (const d of detections) {
    if (isLexiconDetection(d)) {
      total += visibleMatchIds(d).size;
    }
  }
  return total;
}
